import { render, staticRenderFns } from "./SoliStaff.vue?vue&type=template&id=2ff06db0"
import script from "./SoliStaff.vue?vue&type=script&lang=js"
export * from "./SoliStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports